<span *ngIf="gifts.length > 0" class="gift-icon" [tooltip]="'.gift-tooltip'" [offsetLeft]="200" [offsetTop]="-10" [maxWidth]="'400px'">
  <ui-svg-icon svgIcon="reward" size="medium"></ui-svg-icon>
  <div class="tooltip-content">
      <div class="gift-tooltip">
        <div class="gifts-container" *ngFor="let gift of gifts; let last = last">
          <span class="gift-name">{{ 'pricebook.rewards.promo' | translate }} {{getGiftMessage(gift).pricebook}} {{ 'pricebook.rewards.applies' | translate }}</span>
          <span class="gift-message" [innerHTML]="getGiftMessage(gift).message"></span>
          <hr class="separator" *ngIf="!last" />
        </div>  
    </div>
  </div>
</span>